<div class="property-details-fees">
  <div class="property-fees">
    <div class="property-fees-part">
      <p class="property-fees-label dsd-b-10 dsd-mb-0">
        <span [innerText]="'propriete.detail.frais.label' | translate"></span>
        <app-tooltip
          class="info-bulle"
          [ariaLabel]="'propriete.detail.frais.tooltip.sr-only' | translate"
          [id]="'property-fees.idInfobulle'"
          [titre]="'propriete.detail.frais.tooltip.titre' | translate"
          [texte]="'propriete.detail.frais.tooltip.description' | translate"
          [isInsideText]="true"
        ></app-tooltip>
        <span>:</span>
      </p>
      <p class="dsd-b-10 property-fees-edition">
        <app-currency-string
          class="property-fees-amount"
          [value]="currentProperty.montantFraisMensuels"
          [periodicity]="'general.par-mois' | translate"
          [id]="'property-fees-amount'"
        ></app-currency-string
        >&nbsp;
        <button
          (click)="editProperty()"
          class="property-fees-edition-btn no-border"
          id="property-fees-edition-btn"
          [attr.aria-label]="'propriete.detail.frais.modifier' | translate"
        >
          <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
        </button>
      </p>
    </div>
    <div class="property-fees-part" [innerHTML]="'propriete.detail.frais.texte' | translate"></div>
    <div class="property-fees-part">
      <app-tooltip-desktop
        class="property-fees-part-desktop-only"
        [showQuestionMark]="false"
        [isCustomContent]="true"
        [titre]="'propriete.detail.frais.label' | translate"
        [id]="'property-fees-tooltip-info'"
        [isInsideText]="true"
      >
        <a class="property-fees-part-tiroir link questionMark-replacement">
          <span [innerText]="'propriete.detail.frais.tiroir.texte' | translate"></span>
        </a>
        <app-frais-propriete class="custom-content" [propriete]="currentProperty.propriete"></app-frais-propriete>
      </app-tooltip-desktop>
      <button
        class="property-fees-part-tiroir property-fees-part-mobile-only link no-border"
        id="property-fees-part-tiroir"
        (click)="showPropertyFees = !showPropertyFees"
      >
        <span [innerText]="'propriete.detail.frais.tiroir.texte' | translate"></span>
        <img
          [src]="
            showPropertyFees ? 'assets/images/fleche-haut.svg' : ('assets/images/fleche-bas.svg' | cheminAbsoluStatique)
          "
          class="tiroir-icon"
          alt=""
          width="16"
          height="12"
        />
      </button>
      <app-frais-propriete
        *ngIf="showPropertyFees"
        class="property-fees-part-mobile-only property-fees-list"
        [propriete]="currentProperty.propriete"
        [appDynamicBackgroundImage]="getBackgroundImageSource()"
      ></app-frais-propriete>
    </div>
  </div>
  <div class="property-starting-fees" *ngIf="currentProperty.fraisAcquisition as fraisDemarrage">
    <div class="property-starting-fees-part">
      <p class="property-fees-label dsd-b-10 dsd-mb-0">
        <span [innerText]="'propriete.detail.frais.demarrage.label' | translate"></span>
        <app-tooltip
          class="info-bulle"
          [ariaLabel]="'propriete.detail.frais.demarrage.tooltip.sr-only' | translate"
          [id]="'property-fees.starting.idInfobulle'"
          [titre]="'propriete.detail.frais.demarrage.tooltip.titre' | translate"
          [texte]="'propriete.detail.frais.demarrage.tooltip.description' | translate"
          [isInsideText]="true"
        ></app-tooltip>
        <span>:</span>
      </p>
      <p
        class="property-fees-label dsd-b-10"
        [innerHTML]="
          'propriete.detail.frais.demarrage.montant' | translate: { montant: fraisDemarrage | desjardinsCurrency }
        "
      ></p>
    </div>
    <div class="property-starting-fees-part" [innerHTML]="'propriete.detail.frais.demarrage.texte' | translate"></div>
  </div>
  <div
    *ngIf="currentProperty.propriete.analyseEcartPrequalification.montantPrimeAssureurHypothecaire as primeHypotheque"
    class="assurance-prime"
  >
    <div class="assurance-prime-part">
      <p class="property-fees-label dsd-b-10 dsd-mb-0">
        <span>{{ 'propriete.detail.frais.prime-assurance.texte' | translate }}</span>
        <app-tooltip
          class="info-bulle"
          [ariaLabel]="'propriete.detail.frais.prime-assurance.tooltip.sr-only' | translate"
          [id]="'property-fees.prime-assurance.idInfobulle'"
          [titre]="'propriete.detail.frais.prime-assurance.tooltip.titre' | translate"
          [texte]="
            getTextMiseDeFond(
              (donneesEtapeMiseFonds$ | async)?.miseDeFonds,
              miseDeFondDescriptionPart1
                | translate: { miseDeFonds: (donneesEtapeMiseFonds$ | async)?.miseDeFonds | desjardinsCurrency },
              miseDeFondDescriptionPart2
                | translate: { miseDeFondMinimale: currentProperty.miseDeFondMinimale | desjardinsCurrency }
            )
          "
          [placement]="'bottom'"
          [isInsideText]="true"
        ></app-tooltip>
        <span>:</span>
      </p>
      <p
        class="property-fees-label dsd-b-10"
        [innerHTML]="
          'propriete.detail.frais.prime-assurance.montant'
            | translate
              : {
                  prime: primeHypotheque | desjardinsCurrency
                }
        "
      ></p>
    </div>
    <div class="assurance-prime-part" [innerHTML]="'propriete.detail.frais.prime-assurance.inclus' | translate"></div>
  </div>
</div>
